export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";